import { Form } from 'antd';
import styled from 'styled-components';
import CustomerSearchInput from './CustomerSearchInputV2';
import GroupNumberPopover from './GroupNumberPopover';

const BookingV4CustomerSerction = () => {
  return (
    <Container>
      <Row>
        <Form.Item noStyle name={'customer'}>
          <CustomerSearchInput />
        </Form.Item>
        <Form.Item noStyle name={'groupNumber'}>
          <GroupNumberPopover />
        </Form.Item>
      </Row>
    </Container>
  );
};

export default BookingV4CustomerSerction;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;
  background: #fff;
  border-radius: 8px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: stretch;
`;
